import { useState } from 'react';
import { ButtonPest, OptionButton } from '../../../../../../utils/Button';
import InstOption from '../../../../../../utils/InstOption';
import { TextCapitalize } from '../../../../../../utils/TextFormatter';
import cn from '../../../../../../utils/cn';

const billingCycle = [
    { key: 1, value: 'monthly' },
    { key: 3, value: 'quarterly' },
    { key: 6, value: 'half-yearly' },
    { key: 12, value: 'yearly' }
];

function TableRow({
    data,
    isDuration,
    isLifetime,
    isPackageOrProductInactive,
    openModal,
    handleDelete
}) {
    const [itemId, setItemId] = useState(0);

    if (data && data.length === 0) {
        return (
            <tr className="hover:!bg-inherit">
                <td colSpan={6} className="!text-left">
                    No Pricing Found!
                </td>
            </tr>
        );
    }
    return data?.map((item) => (
        <tr
            key={item?.id}
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td className="!pl-5">
                <span>{item?.id}</span>
            </td>
            <td className="text-left">
                <span>{item?.currency?.toUpperCase()}</span>
            </td>
            {!isLifetime && (
                <td className={isDuration ? 'text-left' : 'text-center'}>
                    {isDuration ? (
                        <span className="capitalize">
                            {billingCycle?.find(({ key }) => key === item?.limitByValue)?.value}
                        </span>
                    ) : (
                        <span>{item?.limitByValue}</span>
                    )}
                </td>
            )}
            <td className="text-center">
                <span>{item?.amount}</span>
            </td>
            <td className="text-center">
                <span>{item?.vatPercent}</span>
            </td>

            <td className="text-left">
                <span className={item?.status === 'active' ? 'text-success' : 'text-warning'}>
                    {TextCapitalize(item?.status) || '--'}
                </span>
            </td>
            <td>
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton
                        disabled={isPackageOrProductInactive}
                        onClick={() => setItemId(item?.id)}
                    />

                    <InstOption showMenu={itemId === item?.id} setShowMenu={setItemId}>
                        <button type="button" onClick={() => openModal('package-pricing', item)}>
                            Edit
                        </button>
                        <button type="button" onClick={(e) => handleDelete(e, item?.id)}>
                            Delete
                        </button>
                    </InstOption>
                </div>
            </td>
        </tr>
    ));
}

function TableHeader({ isDuration, isLifetime }) {
    return (
        <thead>
            <tr>
                <th scope="col" width="10%" className="rounded-l-xl text-left !pl-5">
                    <span className="">ID</span>
                </th>
                <th scope="col" className="w-[100px]">
                    <span>Currency</span>
                </th>
                {!isLifetime && (
                    <th scope="col" className={isDuration ? 'text-left' : 'text-center'}>
                        <span>{isDuration ? 'Billing Cycle' : 'PPU Limit'}</span>
                    </th>
                )}
                <th scope="col" className="text-center">
                    <span>Amount</span>
                </th>
                <th scope="col" className="text-center">
                    <span>VAT</span>
                </th>
                <th scope="col" className="w-[100px]">
                    <span>Status</span>
                </th>
                <th scope="col" className="rounded-r-xl text-right !pr-8 after:!content-none w-10">
                    <span>#</span>
                </th>
            </tr>
        </thead>
    );
}

function TableWeb({
    data,
    isDuration,
    isLifetime,
    isPackageOrProductInactive,
    openModal,
    filteredCurrencies,
    handleDelete
}) {
    return (
        <div className="app_page_table pb-40">
            <table className="bik-table mb-4 !w-full" cellPadding={0} cellSpacing={0}>
                <TableHeader isDuration={isDuration} isLifetime={isLifetime} />
                <tbody className="">
                    <TableRow
                        data={data}
                        isDuration={isDuration}
                        isLifetime={isLifetime}
                        isPackageOrProductInactive={isPackageOrProductInactive}
                        handleDelete={handleDelete}
                        openModal={openModal}
                    />
                </tbody>
            </table>
            <div className="flex justify-end">
                <ButtonPest
                    title="Add +"
                    disabled={isPackageOrProductInactive || !filteredCurrencies?.length}
                    onClick={() => openModal('addPrice')}
                />
            </div>
        </div>
    );
}

export default TableWeb;
